import React from "react";
import { useParams, useLocation , NavLink } from "react-router-dom";
import sanityClient from "../../client";
import { usePost } from '../../hooks/usePost';
import BlockContent from "@sanity/block-content-to-react";
import imageUrlBuilder from "@sanity/image-url";
import "./Post.css";
import SimpleHeader from "../../Components/SimpleHeader/SimpleHeader";
import { useTranslation } from "react-i18next";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import SkeletonLoading from "../../Components/SkeletonLoading/Skeleton";

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}
function setTop() {
  window.scrollTo(0, 0);
}

function Post() {
  const { _id } = useParams();
  const query = new URLSearchParams(useLocation().search);
  const index = query.get('index');
  const {post , loadingOne, loading ,prev , next} =  usePost(_id, index);
  const { i18n } = useTranslation();

  const options = {
    settings: {
      boxShadow: "none",
      disableKeyboardControls: false,
      disablePanzoom: true,
      disableWheelControls: false,
      hideControlsAfter: false,
      overlayColor: "rgba(30, 30, 30)",
      slideAnimationType: "fade",
    },
    buttons: {
      showAutoplayButton: true,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: true,
      showPrevButton: true,
      showThumbnailsButton: false,
    },
    caption: {
      showCaption: false,
    },
  };
  
  return (
    <>
      <SimpleHeader />
      <div className="container_post">
        <div className="content">
          {!loadingOne ? (
            <>
              {i18n.language === "es" ? (
                <>
                  <h1>{post[0].title.es}</h1>
                  <div className="blockcontent">
                    {post[0].body &&
                        <BlockContent
                          blocks={post[0].body.es}
                          projectId="68d1bkl8"
                          dataset="production"
                        />
                    }
                  </div>
                </>
              ) : (
                <>
                  <h1>{post[0].title.en}</h1>
                  <div className="blockcontent">
                    {post[0].body &&
                        <BlockContent
                        blocks={post[0].body.en}
                        projectId="68d1bkl8"
                        dataset="production"
                        />
                    }
                  </div>
                </>
              )}
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  {post[0].imagesGallery &&
                    post[0].imagesGallery.map(({ _key, asset }) => (
                    // <div className="img_container">
                      <a
                        href={urlFor(asset).url()}
                        key={_key}
                        className="link_img"
                      >
                        <img
                          className="img_gallery"
                          src={urlFor(asset).url()}
                          alt="img"
                        />
                      </a>
                    // </div>
                  ))}
                </SRLWrapper>
              </SimpleReactLightbox>
              {!loading &&
                <div className="prev_next">
                    {prev &&
                        <NavLink to={"/post/" + prev._id + '?index=' + (parseInt(index) - 1)} onClick={() => setTop()}>
                            {"< " + prev.title.es}
                        </NavLink>

                    }
                    {next &&
                        <NavLink to={"/post/" + next._id + '?index=' + (parseInt(index) + 1)} onClick={() => setTop()} className="next">
                            {next.title.es + " >"}
                        </NavLink>
                    }
                </div>
              }
            </>
          ) : (
            <SkeletonLoading />
          )}
        </div>
      </div>
    </>
  );
}

export default Post;
